import { JWT_TOKEN } from '../constants/Auth'

export function getToken(): string | null {
  return localStorage.getItem(JWT_TOKEN)
}

export function isAuthenticated(): boolean {
  return getToken() != null
}

export function setToken(token: string) {
  return localStorage.setItem(JWT_TOKEN, token)
}

export function removeToken() {
  localStorage.removeItem(JWT_TOKEN)
}



// WEBPACK FOOTER //
// ./src/utils/auth.tsx